<app-loader [isLoading]="isLoading"></app-loader>

<!-- List View -->
<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
</div>

<div class="content list-view">
  <div class="filter">
    <div class="left-section">
      <div class="search-section">
        <mat-form-field appearance="outline" id="toppings">
          <mat-label>Tipo</mat-label>
          <mat-select [formControl]="toppings" multiple>
            @for (topping of toppingList; track topping) {
            <mat-option [value]="topping">{{ topping }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" id="toppings">
          <mat-label>Moderación</mat-label>
          <mat-select [formControl]="programmed" multiple>
            @for (program of programmedList; track program) {
            <mat-option [value]="program">{{ program }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filter-buttons">
        @for (filter of filters; track filter.value){
        <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
          {{ filter.label }}
        </button>
        }
      </div>
    </div>
    <div class="paginator-container">
      <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
        class="paginator-field">
      </mat-paginator>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    <!-- Columna de Id -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.id | mailTitle }}</span>
      </td>
    </ng-container>

    <!-- Columna de Autor -->
    <ng-container matColumnDef="author">
      <th mat-header-cell *matHeaderCellDef>AUTOR</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.employee_external_id | qeqPipe }}</span>
      </td>
    </ng-container>

    <!-- Columna de ID -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>TIPO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.type == 'Events' ? 'Actividades' : 'Noticias' }}</span>
      </td>
    </ng-container>

    <!-- Columna de Publicación -->
    <ng-container matColumnDef="created_when">
      <th mat-header-cell *matHeaderCellDef>HORA PUBLICACIÓN</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.created_when | date:'dd/MM/yyyy HH:mm' }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>TITULO</th>
      <td mat-cell *matCellDef="let element">
        <span [title]="element.title" style="font-size: 16px">{{ element.title | slice:0:50 }}{{ element.title > 50 ? '...' : '' }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="text">
      <th mat-header-cell *matHeaderCellDef>TEXTO</th>
      <td mat-cell *matCellDef="let element">
        <span [title]="element.text" style="font-size: 16px">{{ element.text | slice:0:50 }}{{ element.text > 50 ? '...' : '' }}</span>
      </td>
    </ng-container>

    <!-- Columna de Fecha de notificaciones -->
    <ng-container matColumnDef="is_moreded">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>MODERADO</th>
      <td mat-cell *matCellDef="let element">
          <mat-checkbox
          [checked]="element.is_moderated"
          (change)="onModeratedChange(element, $event.checked)">
          </mat-checkbox>
      </td>
      </ng-container>
      <ng-container matColumnDef="imagenes">
        <th mat-header-cell *matHeaderCellDef>IMÁGENES SUBIDAS</th>
        <td mat-cell *matCellDef="let element">
        <div class="image-gallery" *ngIf="element.images?.length">
        <div class="image-wrapper"  *ngFor="let image of element.images"  >
          <img
            [src]="imageBaseUrl + image.image"
            class="thumbnail"
            [alt]="'Imagen del comentario ' + element.id"
            [matTooltip]="image.is_moderated ? 'Imagen moderada' : 'Imagen aprobada'"
            matTooltipPosition="above"
            (click)="moderarImagen(image)">
          <span *ngIf="image.is_moderated" class="moderation-icon moderated">✕</span>
          <span *ngIf="!image.is_moderated" class="moderation-icon approved">✓</span>
        </div>
        </div>
      </td>
    </ng-container>
     <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
